import { Link } from "react-router-dom";
import { FormularzAnalizy } from "../components/analiza/FormularzAnalizy.js";
import { IconOstrzezenie } from "../components/icons/index.js";
import { Badge } from "../components/ui/Badge.js";
import { Banner } from "../components/ui/Banner.js";
import { Button } from "../components/ui/Button.js";
import { Card } from "../components/ui/Card.js";
import { ProgressBar } from "../components/ui/ProgressBar.js";
import { StanBledu, StanLadowania, StanPusty } from "../components/ui/stany.js";
import { useKonto } from "../hooks/useKonto.js";
import { useListaSesji } from "../hooks/useListaSesji.js";
import { odmien } from "../lib/polski.js";
import { etykietaStatusu, podpisKroku } from "../lib/sessionStatus.js";
import { formatujDlugosc, postepWiersza, wariantStatusu } from "../lib/wierszListy.js";

export function SessionsPage(): React.JSX.Element {
  // Konto `user` widzi "Moje analizy" w uproszczonym ukladzie: bez surowych komunikatow bledow z pipeline'u.
  const { czyAdmin } = useKonto();
  // Lista z odpytywaniem (S-7, BN-1) siedzi w hooku wspolnym z lista konta `user`.
  const { sesje, bladListy, bladOdswiezania, pobierz: pobierzListe } = useListaSesji();

  return (
    <>
      <h1 className="page-title">{czyAdmin ? "Analizy" : "Moje analizy"}</h1>
      <p className="page-lead">
        {czyAdmin
          ? "Wgraj nagranie albo tekst rozmowy i zobacz transkrypcję, ocenę wg metodyki i opis sposobu mówienia."
          : "Wgraj nagranie albo tekst rozmowy i zobacz transkrypcję oraz ocenę wg metodyki."}
      </p>

      {/* BN-1: trwajacy STAN, nie zdarzenie - baner znika sam, gdy odswiezenie
          znowu sie uda. BN-3: przy nim formularz chowa swoj baner o nazwiskach
          (stronaMaBaner), bo to tylko informacja. Ostrzezenie o koszcie dlugiego
          nagrania (w formularzu, nad przyciskiem wysylki) moze stanac obok: to tez
          ostrzezenie, a strona nie wie, kiedy formularz je pokazuje. */}
      {bladOdswiezania && (
        <Banner
          wariant="warning"
          tekst="Nie udaje się odświeżyć listy. Pokazujemy ostatnie dane, jakie mamy."
          akcja={
            <Button wariant="secondary" onClick={() => void pobierzListe(true)}>
              Odśwież
            </Button>
          }
        />
      )}

      <FormularzAnalizy onWgrano={() => pobierzListe(false)} stronaMaBaner={bladOdswiezania} />

      <Card tytul="Wgrane rozmowy">
        {bladListy !== null ? (
          <StanBledu
            tytul="Nie udało się wczytać analiz"
            opis="Serwer nie odpowiedział. Spróbuj ponownie za chwilę."
            szczegol={bladListy}
            akcja={
              <Button wariant="secondary" onClick={() => void pobierzListe(false)}>
                Spróbuj ponownie
              </Button>
            }
          />
        ) : sesje === null ? (
          <StanLadowania tekst="Wczytuję analizy..." />
        ) : sesje.length === 0 ? (
          <StanPusty
            tytul="Nie ma jeszcze żadnej analizy"
            opis="Wgraj pierwszą rozmowę w karcie powyżej - wynik pojawi się na tej liście."
          />
        ) : (
          /* T-5: JEDNA polaczona lista w ramce. Wiersze nie maja wlasnego tla,
             rozdzielaja je hairline'y; w light caly kontener ma jeden wspolny cien. */
          <ul className="rowlist">
            {sesje.map((s) => {
              // Czekanie na zatwierdzenie podzialu nie ma paska: nic sie nie liczy, a pasek
              // sugerowalby prace, ktorej nie ma. Status mowi, ze to ruch uzytkownika.
              const { wToku, procent, tor } = postepWiersza(s);
              const meta = [
                s.inputKind === "TEXT" ? "tekst" : formatujDlugosc(s.durationSec),
                new Date(s.createdAt).toLocaleString("pl-PL"),
                s.utteranceCount > 0
                  ? `${s.utteranceCount} ${odmien(s.utteranceCount, "wypowiedź", "wypowiedzi", "wypowiedzi")}`
                  : null,
              ].filter(Boolean);

              return (
                <li className="rowlist__row sesja-row" key={s.id}>
                  <div className="rowlist__body">
                    <p className="rowlist__nazwa">
                      <Link className="sesja-link" to={`/analizy/${s.id}`}>
                        {s.title}
                      </Link>
                    </p>
                    <p className="rowlist__meta">{meta.join(" - ")}</p>
                    {czyAdmin && s.error && (
                      <p className="rowlist__blad">
                        <IconOstrzezenie size={14} />
                        {s.error}
                      </p>
                    )}
                  </div>

                  {/* S-7: slot ma STALA wysokosc takze dla wierszy gotowych. Inaczej
                      pojawienie sie i znikniecie toru przestawialoby wysokosc wiersza
                      przy kazdym odpytaniu co 3 s. */}
                  <div className="sesja-status">
                    <Badge wariant={wariantStatusu(s.status)} kropka>
                      {etykietaStatusu(s.status)}
                    </Badge>
                    <div className="sesja-status__tor">
                      {wToku && (
                        <ProgressBar
                          etykieta={podpisKroku(s.status, tor)}
                          procent={procent}
                        />
                      )}
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
      </Card>
    </>
  );
}
